import * as t from './actionTypes';

const initialState = {
  workflowWebhooksList: [],
};

const workflowWebhooksReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_WORKFLOW_WEBHOOKS_RESPONSE: {
      return {
        ...state,
        workflowWebhooksList: action.workflowWebhooksList,
      };
    }
    default: {
      return state;
    }
  }
};

export default workflowWebhooksReducer;
